"use client";

import dynamic from "next/dynamic";

/**
 * Lazy client wrappers for the core blocks.
 *
 * next/dynamic only code-splits when the dynamic() call itself lives inside a
 * client boundary. Calling it from the server BlockRenderer maps meant every
 * client block was pulled into each route's client bundle — a blog post shipped
 * InfoBox, Rating, Table, TestimonialSlider and the rest despite never
 * rendering them. Declaring them here gives each block its own chunk, fetched
 * only when a post actually contains that block.
 *
 * Server-component blocks stay in the map files: they must not be imported
 * across a client boundary.
 */

export const Paragraph = dynamic(() => import("@litonarefin/components/CoreBlocks/Paragraph"));
export const Columns = dynamic(() => import("@litonarefin/components/CoreBlocks/Columns"));
export const Column = dynamic(() => import("@litonarefin/components/CoreBlocks/Column"));
export const Code = dynamic(() => import("@litonarefin/components/CoreBlocks/Code"));
export const ListItem = dynamic(() => import("@litonarefin/components/CoreBlocks/ListItem"));
export const Html = dynamic(() => import("@litonarefin/components/CoreBlocks/Html"));
export const Image = dynamic(() => import("@litonarefin/components/CoreBlocks/Image"));
export const Buttons = dynamic(() => import("@litonarefin/components/CoreBlocks/Buttons"));
export const Button = dynamic(() => import("@litonarefin/components/CoreBlocks/Button"));
export const Video = dynamic(() => import("@litonarefin/components/CoreBlocks/Video"));
export const Separator = dynamic(() => import("@litonarefin/components/CoreBlocks/Separator"));
export const Youtube = dynamic(() => import("@litonarefin/components/CoreBlocks/Youtube"));
export const Table = dynamic(() => import("@litonarefin/components/CoreBlocks/Table"));
